import { ENV } from 'gatsby-env-variables'
import analytics from '@mobi/libraries/analytics'
import storage from 'utils/storage'
import { useEffect, useState } from 'react'

const WPP_URL = 'https://api.whatsapp.com/send?phone='
const WPP_NUMBER = ENV === 'prod' ? `551147658402` : `558007732340`
const DEFAULT_TEXT =
  'Olá. Vim do Site de Renegociação, e gostaria de ver as propostas com a Recovery'
const ALT_TEXT = 'Gostaria de consultar meu CPF com a Recovery.'
const UTM_LIST_ALT_TEXT = ['google', 'fb', 'ig', 'adzappy']

const useWhatsAppJourney = () => {
  const [whatsappUrl, setWhatsappUrl] = useState(
    `${WPP_URL}${WPP_NUMBER}&text=${DEFAULT_TEXT}`
  )

  const getUtmSource = () => {
    const utmSourceStorage = storage.local.getItem('utm_source')
    if (utmSourceStorage) {
      return utmSourceStorage
    }
    const url = new URL(window.location.href)
    const utmSourceParam = url.searchParams.get('utm_source')
    if (utmSourceParam) {
      storage.local.setItem('utm_source', utmSourceParam)
      return utmSourceParam
    }
  }

  const resolveWhatsappUrl = () => {
    const utmSource = getUtmSource()
    const isAlternateText = UTM_LIST_ALT_TEXT.includes(utmSource)
    const whatsappMessage = isAlternateText ? ALT_TEXT : DEFAULT_TEXT

    setWhatsappUrl(`${WPP_URL}${WPP_NUMBER}&text=${whatsappMessage}`)
  }

  useEffect(resolveWhatsappUrl, [])

  const handleClick = () => {
    analytics.track('segmentButtonClick', {
      name: 'WhatsappButton',
      id: '5ffdc2f9-f09d-4272-8817-5861a3ff44e0',
    })
    window.open(whatsappUrl)
  }

  return { handleClick, whatsappUrl }
}

export default useWhatsAppJourney
